module.exports = __webpack_public_path__ + "static/media/intercambio 1.d7740b26.svg";